import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { VgImageComponent } from './vg-image.component';
import { VlSpinnerModule } from 'vl-tailwind-layout';
import { PipeModule } from '../../pipes/pipes.module';
import { SkeletonModule } from '../skeleton/skeleton.module';
;

@NgModule({
  imports: [
    CommonModule,
    LazyLoadImageModule,
    VlSpinnerModule,
    PipeModule,
    SkeletonModule
  ],
  declarations: [
    VgImageComponent
  ],
  exports: [
    VgImageComponent
  ]
})
export class VgImageModule { }
